/** Builds the route of the list of dossiers of a type. */
const buildSubjectListPath = (typeKey: string): string => {
	return `/subjects/${typeKey}`;
};

export default buildSubjectListPath;
